import { createSlice } from "@reduxjs/toolkit";
import {
  getUsers,
  getUserById,
  addNewUser,
  updateUser,
  deleteUser,
  getRoles
} from './thunk';

export const initialState = {
  users: [],
  roles: [],
  selectedUser: null,
  isUserSuccess: false,
  isUserAdd: false,
  isUserUpdate: false,
  isUserDelete: false,
  error: {}
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    resetUserFlags: (state) => {
      state.isUserSuccess = false;
      state.isUserAdd = false;
      state.isUserUpdate = false;
      state.isUserDelete = false;
      state.error = {};
    },
    setSelectedUser: (state, action) => {
      state.selectedUser = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUsers.pending, (state) => {
      state.isUserSuccess = false;
    });

    builder.addCase(getUsers.fulfilled, (state, action) => {
      state.users = Array.isArray(action.payload) ? action.payload : action.payload.data || [];
      state.isUserSuccess = true;
      state.error = {};
    });

    builder.addCase(getUsers.rejected, (state, action) => {
      state.error = action.error || {};
      state.isUserSuccess = false;
    });

    builder.addCase(getUserById.fulfilled, (state, action) => {
      state.selectedUser = action.payload;
    });

    builder.addCase(getUserById.rejected, (state, action) => {
      state.error = action.error || {};
    });

    builder.addCase(addNewUser.fulfilled, (state, action) => {
      const newUser = action.payload;
      state.users.push(newUser);
      state.isUserAdd = true;
      state.isUserSuccess = true;
      state.error = {};
    });

    builder.addCase(addNewUser.rejected, (state, action) => {
      state.error = action.error || {};
      state.isUserAdd = false;
    });

    builder.addCase(updateUser.fulfilled, (state, action) => {
      const updatedUser = action.payload;
      state.users = state.users.map(user =>
        user.id === updatedUser.id ? { ...user, ...updatedUser } : user
      );
      state.isUserUpdate = true;
      state.isUserSuccess = true;
      state.error = {};
    });

    builder.addCase(updateUser.rejected, (state, action) => {
      state.error = action.error || {};
      state.isUserUpdate = false;
    });

    builder.addCase(deleteUser.fulfilled, (state, action) => {
      state.users = state.users.filter(user => user.id !== action.payload.id);
      state.isUserDelete = true;
      state.isUserSuccess = true;
      state.error = {};
    });

    builder.addCase(deleteUser.rejected, (state, action) => {
      state.error = action.error || {};
      state.isUserDelete = false;
    });

    builder.addCase(getRoles.fulfilled, (state, action) => {
      state.roles = Array.isArray(action.payload) ? action.payload : action.payload.data || [];
    });

    builder.addCase(getRoles.rejected, (state) => {
      state.roles = [];
    });
  },
});

export const { resetUserFlags, setSelectedUser } = usersSlice.actions;

export default usersSlice.reducer;
